<template>
<div id="div-upgrade-other-container" class="div-lightbox-container">
    <table width="100%" align="left" border="0" cellpadding="0" cellspacing="0">
        <tr>
            <td align="right" colspan="2">
                <a href="javascript:void(0);" onclick="fToggleUpgradeOther();">Close</a>
            </td>
        </tr>
        <tr>
            <td class="subhead" colspan="2">
                We'll Also Upgrade Your Other Device(s)
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="body-copy" colspan="2">
                <p>
                    You currently have a device/devices connected at our High Speed for Free service. By purchasing our Enhanced High Speed service, we will upgrade your other devices-up to 6 total-at no additional charge.
                </p>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="input-field-label" colspan="2" align="center">
                <button class="button-0" style="width:400px" onclick="fConfirmAndSubmit();">Connect all my devices with Enhanced High Speed</button>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td align="right" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="form-spacer">
            </td>
        </tr>
        <tr>
            <td align="left">

            </td>
        </tr>
    </table>
</div>
</template>

<script>

export default {
  name: "UpgradeOtherContainer"
}

</script>

<style scoped>

</style>